import { normalizeSelectValue } from '../../model/normalize-select-value';
import { useGetManufacturersQuery } from 'entities/manufacturers';
import { FC, useMemo } from 'react';
import { Select } from 'shared';

type Props = {
  placeholder?: string;
  manufacturerId?: number;
  onChange: (manufacturerId?: number) => void;
  isClearable: boolean;
};

export const SelectManufacturers: FC<Props> = ({ placeholder, manufacturerId, onChange, isClearable }) => {
  const { data, isFetching } = useGetManufacturersQuery();
  const options = useMemo(
    () =>
      data?.data
        ?.filter((x) => x.id && x.id > 0)
        .map((x) => ({ value: x.id?.toString() ?? '-', label: x.name ?? '-' })) ?? [],
    [data?.data]
  );

  const currentOption = useMemo(
    () => options.find((b) => b.value == manufacturerId?.toString()) ?? null,
    [options, manufacturerId]
  );

  return (
    <Select
      isMulti={false}
      options={options}
      value={currentOption ? [currentOption] : []}
      onChange={(val) => onChange(normalizeSelectValue(val, false)?.[0])}
      placeholder={isFetching ? 'Please wait...' : placeholder ?? ''}
      isClearable={isClearable}
      isDisabled={isFetching}
      instanceId={`Manufacturers-select`}
      highlightSelected
      isSolid
    />
  );
};
